import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth.slice";
import { drawerReducer } from "./drawer.slice";

export * from "./auth.slice";
export * from "./drawer.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    drawer: drawerReducer,
  },
});
